import { createSelector } from 'reselect';

export const getSelectedProductId = state => state.getIn(['products', 'selectedProductId']);
export const getSelectedProductCategoryId = state => state.getIn(['products', 'selectedProductCategoryId']);

export const getAllProductIdList = state => state.getIn(['products', 'productIdList']);
export const getProducts = state => state.getIn(['products', 'products']);
export const getProductIdList = createSelector(
	[getSelectedProductCategoryId, getAllProductIdList, getProducts],
	(selectedProductCategoryId, allProductIdList, products) => {
		let allProductIdListSet = new Set(allProductIdList.toJS());
		return Array.from(allProductIdListSet).filter(productId => {
			if (selectedProductCategoryId === '0') {
				return true;
			}
			if (selectedProductCategoryId === '1') {
				if (products.getIn([productId, 'popular']) === 1) {
					return true;
				}
			} else if (products.getIn([productId, 'categoryId']) === parseInt(selectedProductCategoryId)) {
				return true;
			}
			return false;
		})
	}
)

export const getProductCategoryIdList = state => state.getIn(['products', 'productCategoryIdList']);
export const getProductCategories = state => state.getIn(['products', 'productCategories']);

export const getOrderId = state => state.getIn(['shoppingCompleted', 'orderId']);
export const getPurchaserEmail = state => state.getIn(['shoppingProgress', 'purchaserEmail']);